import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
	deleteMineTeamRoom,
	getMineTeamRooms,
	loadMoreTeamRooms,
	shareSnap,
} from './service';
import {
	getMineTeamRoomsSuccessAction,
	getMineTeamRoomsFailureAction,
	deleteMineTeamRoomSuccessAction,
	getMineTeamRoomsAction,
	loadMoreMineTeamRoomsSuccesAction,
} from './action';

export function* getMineTeamRoomsSaga() {
	try {
		const { data }: AxiosResponse = yield getMineTeamRooms();
		yield put(getMineTeamRoomsSuccessAction(data.data));
	} catch (e) {
		yield put(getMineTeamRoomsFailureAction(e as Error));
	}
}

export function* deleteMineTeamRoomSaga(action: any) {
	const { _id, callback } = action.payload;
	try {
		yield deleteMineTeamRoom(_id);
		yield put(deleteMineTeamRoomSuccessAction(_id));
	} catch (e) {
		console.log(e);
	} finally {
		callback && callback();
	}
}

export function* shareSnapSaga(action: any) {
	const { _id, callback } = action.payload;
	try {
		const { data }: AxiosResponse = yield shareSnap(_id);
		callback && callback(data.data);
		yield put(getMineTeamRoomsAction());
	} catch (e) {
		callback && callback();
	}
}

export function* loadMoreMineTeamRoomsSaga(action: any) {
	const { payload } = action;

	try {
		const { data }: AxiosResponse = yield loadMoreTeamRooms(payload);

		yield put(loadMoreMineTeamRoomsSuccesAction(data.data));
	} catch (e) {
		yield put(getMineTeamRoomsFailureAction(e as Error));
	}
}
